import { Component, OnInit, Input, ViewChild, AfterViewInit, ViewChildren, QueryList, ElementRef, HostBinding, HostListener, Optional, Output, EventEmitter, OnDestroy } from '@angular/core';
import { NgbActiveModal } from '@otas/modal/modal-ref';
import { ContinuosBookingModalService } from './continuos-booking-modal.service';
import moment from 'moment';
import dayjs from 'dayjs';
import { contextMinBookingDate } from '@otas/shared/booking-day-policy';
import { istDayKey, istEpoch, istFormat, istParts } from '@otas/utils/custom-components/panchang-calendar/ist';
import * as _ from 'underscore';
import { PanchangService } from '@otas/utils/custom-components/panchang-calendar/panchang.service';
import { AppConstants, NAKSATRAS, TITHI, ML_MONTHS, WEEKDAYS, EN_MONTHS } from '../../app.constants';
import { ToasterService } from '../../services/toaster.service';
import { DateService } from '../../services/date.service';
import { TranslatePipe } from '@otas/translate/translate.pipe';
import { TranslateService } from '@otas/translate/translate.service';
import { PanEventJson } from '@otas/model/panchang/panchangam-json';
import { UntypedFormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { BehaviorSubject, Subject } from 'rxjs';
import { isNullOrUndefined } from '../../../utils/util/util';
@Component({
    selector: 'app-continuos-booking-modal',
    templateUrl: './continuos-booking-modal.component.html',
    styleUrls: ['./continuos-booking-modal.component.css'],
    providers: [ContinuosBookingModalService],
    standalone: false
})
export class ContinuosBookingModalComponent implements OnInit, AfterViewInit, OnDestroy {
    translatorPipe;
    isPradosham = false;
    @Input() keyboard: 'english' | 'malayalam' | 'manglish';
    allMonths: any[];
    allNakshathram: any[] = [];
    allThithi: any[] = [];
    allWeek: any[] = [];
    vazipaduId;
    panEvents: any[] = [];
    displaypanEvents: PanEventJson[] = [];
    poojaDateList: any[] = [];
    datePickerOptions: any = AppConstants.datePickerOptions;
    @Input() fromDate: Date;
    totalAvailableDate = 0;
    totalSliceCount = 0;
    enMonth = '';
    @Input() toDate: Date;
    message;
    numberOfDtes = 0;
    week; thidhi; star; varsham;
    loading = false;
    checkbox = false;
    maxLimit: number;
    @Input() datesTobeRemoved: any = [];
    other;
    bookedCount: number;
    isWeekFilter = false;
    weekOption = 0;
    monthOption = -1;
    weekFilterOptions: any[] = [];
    monthSubFilterOptions: any[] = [{ id: -1, text: 'ALL' }];
    filteredDisplaypanEvents: any[] = [];
    tempDisplaypanEvents: any[] = [];
    @HostBinding('tabindex') tabindex = -1;
    isMalayalamLang = false;
    panchangCalenderOpts = { keyboardNavigation: true, startDate: new Date() };
    autoCompleteSettings = { isFocusFirstElement: true, needSelection: true, selectionOnclick: true, isClearAll: true }
    allEnMonths: any[];
    totalFormControl = new UntypedFormControl(this.totalAvailableDate);
    @ViewChild('totalInput', { static: true }) totalInputRef: ElementRef;
    panchangFor50Year: any[];
    isMonthFilter: boolean;
    fromDateChange: Subject<any> = new Subject();
    toDateChange: Subject<any> = new Subject();
    @Output() selectedDates = new EventEmitter();
    quantity?: number;
    private afterRecalculationSetCount: number | null = null;
    private destroy$ = new Subject<void>();

    constructor(private elementRef: ElementRef, private continuosBookingModalService: ContinuosBookingModalService,
        @Optional() public activeModal: NgbActiveModal, private ts: TranslateService,
        public toastr: ToasterService, private panService: PanchangService) {
        this.translatorPipe = new TranslatePipe(this.ts);
        this.panService.ensureLoaded();
        this.panchangFor50Year = _.map(this.panService.panchangFor50Year);
        this.fromDate = new Date();
        this.toDate = moment().add(1, 'year').toDate();

        // this.displaypanEvents = _.map(this.panService.panchangForOneYear);
        this.datePickerOptions.startDate = new Date();
        this.datePickerOptions.keyboardNavigation = false;
        const isMalayalam = sessionStorage.getItem('language') === 'malayalam';
        this.isMalayalamLang = isMalayalam;
        this.totalAvailableDate = this.displaypanEvents.length;
        this.totalFormControl.setValue(this.totalAvailableDate);
        this.displaypanEvents.forEach(element => {
            element.selected = true;
        });
        this.allMonths = [{ month: 'Malayalam 1', id: -1, name: this.translatorPipe.transform('Malayalam', '') + ' 1', prefix: 0 + '.' }];
        this.allEnMonths = [{ month: 'English 1', id: -1, name: this.translatorPipe.transform('English', '') + ' 1', prefix: 0 + '.' }];
    }
    onPradoshamChange(value) {
        this.isPradosham = value;
        if (this.isPradosham) {
            this.displaypanEvents = this.panService.calculatePanchang(this.fromDate, this.toDate).filter(e => !!e.pradosham);
            this.totalAvailableDate = this.displaypanEvents.length;
            this.totalFormControl.setValue(this.totalAvailableDate);
            this.displaypanEvents.forEach(element => {
                element.selected = true;
            });
            this.checkbox = true;
        } else {
            const toDate: any = moment(this.toDate).toDate() as any * 1;
            this.toDate = moment(toDate).toDate()
        }
        // console.log(this.displaypanEvents);

    }
    configureAllAutoCompleteOptions() {
        const isMalayalam = sessionStorage.getItem('language') === 'malayalam';
        this.allNakshathram = isMalayalam ?
            _.map(NAKSATRAS, (e, i) => { return { id: e.ml, name: e.ml, prefix: (i) + '.' } })
            : _.map(NAKSATRAS, (e, i) => { return { id: e.en, name: e.en, prefix: (i) + '.' } });

        this.allThithi = isMalayalam ? _.map(TITHI, (e, i) => { return { id: e.ml, name: e.ml, prefix: (i + 1) + '.' } }) : _.map(TITHI, (e, i) => { return { id: e.en, name: e.en, prefix: (i + 1) + '.' } });
        const allMonths = isMalayalam ? _.map(ML_MONTHS, (e, i) => { return { month: e.ml, id: e.ml, name: e.ml, prefix: (i + 1) + '.' } }) : _.map(ML_MONTHS, (e, i) => { return { month: e.en, id: e.en, name: e.en, prefix: (i + 1) + '.' } });
        this.allMonths = _.union(this.allMonths, allMonths);
        const allEnMonths = isMalayalam ? _.map(EN_MONTHS, e => { return { month: e.ml, id: e.id + 1, name: e.ml, prefix: (e.id + 1) + '.' } }) : _.map(EN_MONTHS, e => { return { month: e.en, id: e.id + 1, name: e.en, prefix: (e.id + 1) + '.' } });
        this.allEnMonths = _.union(this.allEnMonths, allEnMonths);
        this.allWeek = isMalayalam ? _.map(WEEKDAYS, (e, i) => { return { id: e.ml, name: e.ml, prefix: (i + 1) + '.' } }) : _.map(WEEKDAYS, (e, i) => { return { id: e.en, name: e.en, prefix: (i + 1) + '.' } });

    }
    countSubject = new BehaviorSubject(0);
    trackByFn(index, item) {

        return item.date; // or item.id
    }
    ngOnInit() {
        this.autoCompleteSettings['keyboard'] = this.keyboard;
        // console.log(this.fromDate);

        this.toDateChange.pipe(debounceTime(100), takeUntil(this.destroy$)).subscribe((e) => {
            if (!!e) {
                if (!this.isPradosham) {
                    this.panEvents = this.panService.calculatePanchang(this.fromDate, this.toDate);
                    this.removeDates();
                    this.displaypanEvents = _.map(this.panEvents);
                    this.displaypanEvents = _.map(this.displaypanEvents, e => { e.selected = true; return e; })

                    this.enMonth && this.panchangFilter(this.enMonth, 'enMonth');

                    this.varsham && this.panchangFilter(this.varsham, 'year');
                    this.week && this.panchangFilter(this.week, 'week');
                    this.thidhi && this.panchangFilter(this.thidhi, 'thithi');
                    this.star && this.panchangFilter(this.star, 'nakshathra');
                    this.numberOfDtes = this.displaypanEvents.length;
                    this.displaypanEvents = _.map(this.displaypanEvents).slice(0, +this.numberOfDtes, e => { e.selected = true; return e; });
                    this.checkbox = true;
                    this.totalAvailableDate = this.displaypanEvents.length;
                    this.totalFormControl.setValue(this.totalAvailableDate);
                    if (this.afterRecalculationSetCount) {
                        const count = this.afterRecalculationSetCount;
                        this.afterRecalculationSetCount = null;
                        this.onAvailableDateSearchChange(count);
                    }
                } else {
                    this.onPradoshamChange(true);
                }

            }
            this.loading = false;
            this.elementRef.nativeElement.focus();
            this.numberOfDtes = this.displaypanEvents.filter(e => !!e.selected).length;

        });
        // Update the fromDateChange subscription
        this.fromDateChange.pipe(debounceTime(100), takeUntil(this.destroy$)).subscribe((e) => {
            if (!!e) {
                this.loading = true;
                const selectedDates = this.displaypanEvents
                    .filter(event => event.selected)
                    .map(event => istFormat(event.date, 'YYYY-MM-DD'));
                this.panEvents = this.panService.calculatePanchang(this.fromDate, this.toDate);
                this.tempDisplaypanEvents = [...this.panEvents];
                this.removeDates();
                this.displaypanEvents = _.map(this.panEvents, event => {
                    return {
                        ...event,
                        selected: selectedDates.includes(istFormat(event.date, 'YYYY-MM-DD'))
                    };
                });

                this.enMonth && this.panchangFilter(this.enMonth, 'enMonth');
                this.varsham && this.panchangFilter(this.varsham, 'year');
                this.week && this.panchangFilter(this.week, 'week');
                this.thidhi && this.panchangFilter(this.thidhi, 'thithi');
                this.star && this.panchangFilter(this.star, 'nakshathra');
                // SPECIAL CASE: When no filters are applied
                if (!this.enMonth && !this.varsham && !this.week && !this.thidhi && !this.star) {
                    this.totalAvailableDate = this.displaypanEvents.length;
                    this.totalFormControl.setValue(this.totalAvailableDate);
                }
                this.displaypanEvents.forEach(event => event.selected = true);
                // Update counts
                this.numberOfDtes = this.displaypanEvents.filter(ele => !!ele.selected).length;
                this.checkbox = true;
                this.loading = false;
                this.elementRef.nativeElement.focus();
            }
        });
        this.configureAllAutoCompleteOptions();
        this.setWeekFilterOptions('');
        this.countSubject.pipe(debounceTime(500), takeUntil(this.destroy$)).subscribe((data) => {
            if (+data) {
                this.calculateEnmonthByChangeInput();
                this.onAvailableDateSearchChange(+data)
            } else {
                this.totalFormControl.setValue(this.displaypanEvents.length)
            }
        });
        // this.totalFormControl.valueChanges.pipe(debounceTime(200), distinctUntilChanged()).subscribe((data) => {
        //     if (+data) {
        //         this.changeInput(+data);
        //         this.onAvailableDateSearchChange(+data)
        //     } else {
        //         this.totalFormControl.setValue(this.panEvents.length)
        //     }
        // });
        this.monthChangeSub.pipe(distinctUntilChanged(), takeUntil(this.destroy$)).subscribe(($event) => {
            this.panchangFilter($event, 'enMonth')
            this.configureMonthSubfilter($event)
        })
        this.handleDateFromChange(this.fromDate);
        this.handleDateToChange(this.toDate);
    }
    @HostListener('focus')
    focus() {
        this.totalInputRef.nativeElement.focus()
    }
    ngAfterViewInit() {

    }
    getDateFormatted(date) {
        const formattedDate = DateService.dateToFormattedString(date, 'DD-MMM-YYYY');
        return formattedDate;
    }

    // ---- app-date-picker bridge (the shared picker speaks dayjs; the whole
    // calculation pipeline here stays on native Date — no logic change) -----

    /** From-date floor: the booking-day policy's context minimum (counter =
     *  today or the past window; portal = the online minimum). null (PAST)
     *  leaves the picker unbounded. */
    readonly fromMinDate = (() => {
        const min = contextMinBookingDate();
        // Present the IST calendar day (dayjs of an epoch would decompose in
        // the browser's zone and show the previous day west of IST).
        return min ? dayjs(istFormat(min, 'YYYY-MM-DD')) : null;
    })();
    /** Kollavarsham calculator guard — panchang.json ends 2050-12-31 and the
     *  calculator extends beyond it; 2100 is a generous ceiling. */
    readonly pickerMaxDate = dayjs('2100-12-31');

    // MEMOIZED: these feed [ngModel]/[minDate] bindings, so they MUST return
    // the SAME instance until the underlying date actually changes. A plain
    // `dayjs(this.fromDate)` getter mints a new object every change-detection
    // cycle -> NgModel calls writeValue -> the picker regenerates its calendar
    // -> more CD ... a storm that froze the whole booking screen.
    private fromDjCache: dayjs.Dayjs | null = null;
    private fromDjKey = NaN;
    private toDjCache: dayjs.Dayjs | null = null;
    private toDjKey = NaN;

    get fromDateDayjs(): dayjs.Dayjs | null {
        const time = this.fromDate ? new Date(this.fromDate as any).getTime() : NaN;
        if (isNaN(time)) {
            this.fromDjCache = null;
            this.fromDjKey = NaN;
        } else if (!this.fromDjCache || this.fromDjKey !== time) {
            this.fromDjKey = time;
            // Display the instant's IST calendar day on any host.
            this.fromDjCache = dayjs(istFormat(time, 'YYYY-MM-DD'));
        }
        return this.fromDjCache;
    }
    get toDateDayjs(): dayjs.Dayjs | null {
        const time = this.toDate ? new Date(this.toDate as any).getTime() : NaN;
        if (isNaN(time)) {
            this.toDjCache = null;
            this.toDjKey = NaN;
        } else if (!this.toDjCache || this.toDjKey !== time) {
            this.toDjKey = time;
            this.toDjCache = dayjs(istFormat(time, 'YYYY-MM-DD'));
        }
        return this.toDjCache;
    }
    get toMinDate(): dayjs.Dayjs | null {
        return this.fromDateDayjs || this.fromMinDate;
    }

    onFromDatePicked(value: any) {
        const picked = this.pickedToDate(value);
        if (!picked) { return; }
        this.fromDate = picked;
        this.handleDateFromChange(picked);
    }

    onToDatePicked(value: any) {
        const picked = this.pickedToDate(value);
        if (!picked) { return; }
        this.toDate = picked;
        this.handleDateToChange(picked);
    }

    private pickedToDate(value: any): Date | null {
        if (!value) { return null; }
        const date: Date = typeof value.toDate === 'function' ? value.toDate() : new Date(value);
        if (isNaN(date.getTime())) { return null; }
        // The picker's calendar fields are the user's intended day — pin that
        // day at IST midnight (was host-local setHours(0,0,0,0)).
        return new Date(istEpoch(date.getFullYear(), date.getMonth(), date.getDate()));
    }
    handleDateToChange(e) {
        this.clear();
        if (!!e) {
            this.loading = true;
            this.toDateChange.next(e);


        }
    }


    handleDateFromChange(e) {
        this.clear();
        if (!!e) {
            this.loading = true;
            this.fromDateChange.next(e)

        }
    }
    removeDates() {
        if (!!this.datesTobeRemoved && !!this.datesTobeRemoved.length) {
            // Same-day de-dup on the IST day grid (was host-local day equality).
            this.panEvents = _.filter(this.panEvents, p => !_.some(this.datesTobeRemoved, d => istDayKey(d) === istDayKey(p.date)));
        }
    }
    check() {
        this.numberOfDtes = 0;
        this.checkbox = !!this.checkbox ? false : true;
        if (this.checkbox) {
            const index = this.totalAvailableDate;
            for (let i = 0; i < index; i++) {
                const element = this.displaypanEvents[i];
                element.selected = true;
                this.numberOfDtes = this.numberOfDtes + 1;
            }
        } else {
            this.displaypanEvents.forEach(element => {
                element.selected = false;
                // this.numberOfDtes = this.numberOfDtes - 1;
            });
        }
        const selectedPanEvents = _.filter(this.displaypanEvents, e => !!e.selected);
        this.numberOfDtes = selectedPanEvents.length;
    }
    panchangFilterByEnMonth(e) {
        if (!!e && +e >= 0) {
            // Month/day-of-month buckets on the IST calendar (was host-local).
            this.displaypanEvents = _.filter(this.panEvents, element => istParts(element.date).month === +e - 1)


        } else if (+e === -1) {
            this.displaypanEvents = _.filter(this.panEvents, element => istParts(element.date).day === 1);

        }
        else {
            this.displaypanEvents = _.map(this.panEvents);
        }
        if (this.isMonthFilter && +this.monthOption > 0) {
            this.displaypanEvents = _.filter(this.displaypanEvents, e => istParts(e.date).day === +this.monthOption);

        }
        this.totalAvailableDate = this.displaypanEvents.length;
        this.totalFormControl.setValue(this.totalAvailableDate);
    }
    onFocus(event) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        setTimeout(() => {
            const node = event.target || event;
            node.setSelectionRange(0, node.value.length);
        }, 125);


    }
    monthChangeSub = new Subject();
    configureMonthSubfilter(event) {

        this.monthSubFilterOptions = this.continuosBookingModalService.getMonthSubFilterOptions(event);

    }
    panchangFilter(e, type?: string, reverse = true) {
        // if (!this.enMonth && !this.varsham && !this.week && !this.thidhi && !this.star) {
        //     return;
        // }        
        this.varsham = type === 'year' ? e : this.varsham;
        this.enMonth = type === 'enMonth' ? e : this.enMonth;
        this.week = type === 'week' ? e : this.week;
        this.thidhi = type === 'thithi' ? e : this.thidhi;
        this.star = type === 'nakshathra' ? e : this.star;
        this.checkbox = false;
        this.numberOfDtes = 0;
        const lang = sessionStorage.getItem('language') === 'malayalam';
        const selKey = lang ? type : ('en' + type.charAt(0).toUpperCase() + type.slice(1));
        type = type === 'enMonth' ? type : selKey;
        this.isMonthFilter = !isNaN(+this.enMonth) && +this.enMonth > 0;

        this.displaypanEvents.forEach(element => {
            element.selected = true;
        });
        if (!!e) {
            this.displaypanEvents = [];
            if (type === 'enMonth') {
                this.panchangFilterByEnMonth(e ? e : +this.enMonth);

            } else {

                this.panEvents.forEach(element => {
                    if (element[type].includes(e)) {
                        this.displaypanEvents.push(element);
                    }
                });
            }

        } else {
            this.displaypanEvents = _.map(this.panEvents);
            this.totalAvailableDate = this.displaypanEvents.length;
            reverse && this.totalFormControl.setValue(this.totalAvailableDate);
        }
        if (this.enMonth) {
            //   console.log("yes")
            this.panchangFilterByEnMonth(+this.enMonth);
        } else {
            this.monthOption = -1;
        }
        if (this.week) {
            const weekKey = lang ? 'week' : 'enWeek';
            this.displaypanEvents = _.filter(this.displaypanEvents, ele => ele[weekKey].includes(this.week));
            this.totalAvailableDate = this.displaypanEvents.length;
            reverse && this.totalFormControl.setValue(this.totalAvailableDate);
            this.isWeekFilter = true;
        } else {
            this.isWeekFilter = false;
            this.weekOption = 0;

        }
        if (this.varsham) {
            const yearKey = lang ? 'year' : ('enYear');
            if (+this.varsham === -1) {
                this.displaypanEvents = _.filter(this.displaypanEvents, ele => (ele[yearKey].slice(-2)).includes(this.varsham));
                this.totalAvailableDate = this.displaypanEvents.length;
            } else {
                this.displaypanEvents = _.filter(this.displaypanEvents, ele => ele[yearKey].includes(this.varsham));
                this.totalAvailableDate = this.displaypanEvents.length;
            }
            reverse && this.totalFormControl.setValue(this.totalAvailableDate);
        }
        if (this.thidhi) {
            const thithiKey = lang ? 'thithi' : ('enThithi');
            this.displaypanEvents = _.filter(this.displaypanEvents, ele => ele[thithiKey].includes(this.thidhi));
            this.totalAvailableDate = this.displaypanEvents.length;
            reverse && this.totalFormControl.setValue(this.totalAvailableDate);
        }
        if (this.star) {
            const nakshathraKey = lang ? 'nakshathra' : ('enNakshathra');
            this.displaypanEvents = _.filter(this.displaypanEvents, ele => ele[nakshathraKey].includes(this.star));
            this.totalAvailableDate = this.displaypanEvents.length;

            reverse && this.totalFormControl.setValue(this.totalAvailableDate);
        }
        this.weekFilterOptionsChange(+this.weekOption);
        if (!this.displaypanEvents.length) {
            this.displaypanEvents = [];
            this.displaypanEvents = _.map(this.panEvents);
            this.totalAvailableDate = this.displaypanEvents.length;
            setTimeout(() => { this.weekOption = 0; this.star = null; this.enMonth = null; this.week = null; this.varsham = null; this.thidhi = null; }, 100);

            reverse && this.totalFormControl.setValue(this.totalAvailableDate);
            this.elementRef.nativeElement.focus();

        }
        this.tempDisplaypanEvents = [];
        this.tempDisplaypanEvents = this.displaypanEvents;
        this.fixQuantityWhileFilter();
        const selectedPanEvents = _.filter(this.displaypanEvents, e => !!e.selected);
        this.numberOfDtes = selectedPanEvents.length;
        this.totalAvailableDate = this.displaypanEvents.length;
        reverse && this.totalFormControl.setValue(this.totalAvailableDate);

        this.checkbox = selectedPanEvents.length === this.displaypanEvents.length;
        // this.setFilterModel();
    }
    clear() {
        // this.star = null; this.week = null; this.varsham = null; this.thidhi = null;
        this.checkbox = false;
        this.numberOfDtes = 0;
        this.displaypanEvents.forEach(element => {
            element.selected = false;
        });
    }

    fixQuantityWhileFilter() {
        if (!!this.quantity) {
            if (this.displaypanEvents.length < this.quantity)
                this.calculateEnmonthByChangeInput();
            this.displaypanEvents.splice(this.quantity);
        }
    }

    select(object) {
        object.selected = !!object.selected ? false : true;
        if (!object.selected) {
            this.numberOfDtes = this.numberOfDtes - 1;
            this.checkbox = false;
        }
        if (!!object.selected) {
            this.numberOfDtes = this.numberOfDtes + 1;
        }
        const obj = _.filter(this.displaypanEvents, e => {
            return !e.selected;
        });
        if (!obj.length) { this.checkbox = true; }
        const selectedPanEvents = _.filter(this.displaypanEvents, e => !!e.selected);
        this.numberOfDtes = selectedPanEvents.length;
    }
    close() {
        this.activeModal?.dismiss(false);
        // this.setFilterModel();
    }
    continuosBooking() {
        this.poojaDateList = [];
        this.displaypanEvents.forEach(element => {
            if (!!element.selected) {
                this.poojaDateList.push(element.date);
                this.poojaDateList = _.uniq(this.poojaDateList);
            }
        });
        if (!this.poojaDateList.length) {
            this.toastr.warning('Please choose dates for continuos booking');
        }
        if (!!this.poojaDateList.length) {
            this.continuosBookingModalService.myMethod(this.poojaDateList);

            this.selectedDates.emit(this.poojaDateList);

            this.activeModal?.close(this.poojaDateList);

        }


    }
    changeInput(e) {
        // console.log("change inp", e);
        this.enMonth && this.panchangFilter(this.enMonth, 'enMonth', false);
        this.varsham && this.panchangFilter(this.varsham, 'year', false);
        this.week && this.panchangFilter(this.week, 'week', false);
        this.thidhi && this.panchangFilter(this.thidhi, 'thithi', false);
        this.star && this.panchangFilter(this.star, 'nakshathra', false);
        this.calculateEnmonthByChangeInput();

        if (!this.displaypanEvents.length) {
            this.displaypanEvents = _.map(this.panEvents).slice(0, 367);

        }

        if (this.displaypanEvents.length < +e) {
            if (!this.enMonth &&
                !this.varsham &&
                !this.week &&
                !this.thidhi &&
                !this.star) {
                this.displaypanEvents = _.map(this.panEvents).slice(0, +e);

            } else {
                // this.panEvents = _.map(this.panService.panchangForOneYear);
                this.calculateEnmonthByChangeInput();
                this.varsham && this.panchangFilter(this.varsham, 'year');
                this.week && this.panchangFilter(this.week, 'week');
                this.thidhi && this.panchangFilter(this.thidhi, 'thithi');
                this.star && this.panchangFilter(this.star, 'nakshathra');
                this.displaypanEvents = _.map(this.displaypanEvents).slice(0, +e);
            }

        }
        this.displaypanEvents = _.map(this.displaypanEvents).slice(0, +e);
        const len = this.displaypanEvents.length;
        this.numberOfDtes = _.filter(this.displaypanEvents, ele => !!ele.selected).length;
        this.totalAvailableDate = (!!e && e > 0 && e <= len) ? e : len;

        if (!e) {
            this.totalFormControl.setValue(this.panEvents.length)
        }

    }

    calculateEnmonthByChangeInput() {
        const inputValue = !!this.quantity ? this.quantity : +this.countSubject.value;
        const enMonth = +this.enMonth;
        const varsham = this.varsham;
        const week = this.week;
        const thidhi = this.thidhi;
        const star = this.star;
        let selectedFilters = {};
        if (enMonth) {
            Object.assign(selectedFilters, { enMonth });
            if (this.isMonthFilter && +this.monthOption > 0) {
                Object.assign(selectedFilters, { monthOption: +this.monthOption });

            }

        }
        if (!isNullOrUndefined(varsham)) {
            Object.assign(selectedFilters, { varsham })

        }
        if (!isNullOrUndefined(thidhi)) {
            Object.assign(selectedFilters, { thidhi })

        }
        if (!isNullOrUndefined(week)) {
            Object.assign(selectedFilters, { week });
            const obj = _.find(this.weekFilterOptions, ele => +ele.id === +this.weekOption);
            const weekOption = obj;
            if (!isNullOrUndefined(weekOption)) {

                Object.assign(selectedFilters, { weekOption });
            }

        }
        if (!isNullOrUndefined(star)) {
            Object.assign(selectedFilters, { star })

        }
        const panchangFor50Year = _.filter(this.panchangFor50Year, p => !_.some(this.datesTobeRemoved || [], d => istDayKey(d) === istDayKey(p.date)));
        if (Object.keys(selectedFilters).length) {
            this.toDate = this.continuosBookingModalService.panchangFilter(selectedFilters, _.map(panchangFor50Year), inputValue, this.fromDate);
        } else {
            this.toDate = this.continuosBookingModalService.countFromDateToToDate(this.fromDate, _.map(panchangFor50Year), inputValue)
        }

    }
    onAvailableDateSearchChange(e: number) {
        const sourceData = this.tempDisplaypanEvents.length > 0
            ? this.tempDisplaypanEvents
            : this.displaypanEvents;

        if (e > sourceData.length) {
            this.afterRecalculationSetCount = e;
            this.quantity = e;
            this.calculateEnmonthByChangeInput();
            this.toDateChange.next(this.toDate);
            return;
        }
        if (e > 0) {
            this.displaypanEvents = sourceData.slice(0, e);
            this.totalAvailableDate = this.displaypanEvents.length;
            this.displaypanEvents.forEach(ele => ele.selected = true);
            this.numberOfDtes = this.displaypanEvents.filter(ele => !!ele.selected).length;
        } else {
            this.displaypanEvents = _.map(sourceData);
            this.totalAvailableDate = this.displaypanEvents.length;
            this.numberOfDtes = this.displaypanEvents.filter(ele => !!ele.selected).length;
        }
        this.totalFormControl.setValue(this.totalAvailableDate);

    }

    setWeekFilterOptions(week: string) {
        if (!!week) {
            this.displaypanEvents.forEach(element => {
                element.selected = true;
            });
        }
        this.weekFilterOptions = [];

        this.weekFilterOptions.push({ 'id': 1, 'week': '1', 'name': 'm: 1st ' + week, 'type': 'ml' });
        this.weekFilterOptions.push({ 'id': 2, 'week': '2', 'name': 'm: 2nd ' + week, 'type': 'ml' });
        this.weekFilterOptions.push({ 'id': 3, 'week': '3', 'name': 'm: 3rd ' + week, 'type': 'ml' });
        this.weekFilterOptions.push({ 'id': 4, 'week': '4', 'name': 'm: 4th ' + week, 'type': 'ml' });
        this.weekFilterOptions.push({ 'id': 5, 'week': '5', 'name': 'm: Last ' + week, 'type': 'ml' });

        this.weekFilterOptions.push({ 'id': 6, 'week': '1', 'name': 'e: 1st ' + week, 'type': 'en' });
        this.weekFilterOptions.push({ 'id': 7, 'week': '2', 'name': 'e: 2nd ' + week, 'type': 'en' });
        this.weekFilterOptions.push({ 'id': 8, 'week': '3', 'name': 'e: 3rd ' + week, 'type': 'en' });
        this.weekFilterOptions.push({ 'id': 9, 'week': '4', 'name': 'e: 4th ' + week, 'type': 'en' });
        this.weekFilterOptions.push({ 'id': 10, 'week': '5', 'name': 'e: Last ' + week, 'type': 'en' });
    }

    weekFilterOptionsChange(id: number) {
        this.displaypanEvents.forEach(element => {
            element.selected = false;
        });
        if (+id > 0) {
            const obj = _.find(this.weekFilterOptions, ele => +ele.id === +id);
            if (obj.type.trim() === 'ml') {
                if (+obj.week < 5) {

                    // _.map(this.displaypanEvents, (p: PanEventJson) => {
                    //   const a: moment.Moment = getGivenDateOfMonth(moment(p.date).toDate(), 0, 2);
                    //   console.log(moment(p.date).week() - moment(p.date).startOf('month').week() + 1, moment(p.date).format('DD-MMM-YYYY'));
                    //   return p;
                    // })

                    this.displaypanEvents = _.map(_.filter(this.displaypanEvents, ele => (this.transform(ele['year'], +obj.week, obj.type) === true)), e => { e.selected = true; return e; })
                } else {
                    _.filter(this.displaypanEvents, ele => (this.transform(ele['year'], +obj.week, obj.type) === true
                        || (this.transform(ele['year'], +obj.week - 1, obj.type) === true && this.transform(ele['year'], +obj.week, obj.type) === false))).forEach(element => {
                            element.selected = true;
                            if ((this.transform(element['year'], +obj.week, obj.type) === true)) {
                                if (!!this.displaypanEvents[this.displaypanEvents.indexOf(element) - 1]) {
                                    if (this.displaypanEvents[this.displaypanEvents.indexOf(element) - 1].selected) {
                                        this.displaypanEvents[this.displaypanEvents.indexOf(element) - 1].selected = false;
                                    }
                                }
                            }

                        });
                    this.displaypanEvents = _.filter(this.displaypanEvents, ele => ele.selected);
                }

            } else {
                if (+obj.week < 5) {
                    this.displaypanEvents = _.map(_.filter(this.displaypanEvents, ele => (this.transform(ele['date'], +obj.week, obj.type) === true)), e => { e.selected = true; return e; });
                } else {
                    _.filter(this.displaypanEvents, ele => (
                        (this.transform(ele['date'], +obj.week, obj.type) === true) ||
                        (this.transform(ele['date'], +obj.week, obj.type) === false && this.transform(ele['date'], +obj.week - 1, obj.type) === true)

                    )).forEach(element => {
                        element.selected = true;
                        if ((this.transform(element['date'], +obj.week, obj.type) === true)) {
                            if (!!this.displaypanEvents[this.displaypanEvents.indexOf(element) - 1]) {
                                if (this.displaypanEvents[this.displaypanEvents.indexOf(element) - 1].selected) {
                                    this.displaypanEvents[this.displaypanEvents.indexOf(element) - 1].selected = false;
                                }
                            }
                        }

                    });
                    this.displaypanEvents = _.filter(this.displaypanEvents, ele => ele.selected);
                }
            }

        }
        else {
            this.displaypanEvents.forEach(element => {
                element.selected = true;
            });
        }
    }
    transform(dateStamp: any, week: number, type: string): boolean {

        if (type.trim() === 'en') {
            let date = (new Date(dateStamp).getDate());
            let weekNo = (+date / 7); // Math.floor     
            // return (+weekNo === (week-1));
            return (+weekNo > (week - 1) && (+weekNo <= (week)));
        } else {
            let str = dateStamp.split('-')[2];
            let weekNo = (+str / 7); // Math.floor
            //  return (+weekNo === (week-1)); 
            return (+weekNo > (week - 1) && (+weekNo <= (week)));
        }
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
        this.panEvents = [];
        this.displaypanEvents = [];
        this.panchangFor50Year = [];
        this.tempDisplaypanEvents = [];
        this.poojaDateList = [];
    }

}
function getGivenDateOfMonth(startDate, dayOfWeek, weekNumber) {
    var startOfMonth = moment(startDate).startOf('month').startOf('week');
    var dayOne = moment((moment(startDate, "YYYY-MM-DD").format("YYYY-MM") + "-01"), "YYYY-MM-DD");
    var studyDate;
    if (dayOne.weekday() === 1) {
        studyDate = moment(startDate).startOf('month').startOf('week').add(dayOfWeek, 'days')
            .add(weekNumber, 'w');
    }
    else if (dayOne.weekday() <= dayOfWeek) {
        studyDate = moment(startDate).startOf('month').startOf('week').add(dayOfWeek, 'days')
            .add(weekNumber - 1, 'w');
    } else {
        studyDate = moment(startDate).startOf('month').startOf('week').add(dayOfWeek, 'days')
            .add(weekNumber, 'w');
    }
    if (studyDate.month() == startOfMonth.month()) {
        studyDate = studyDate.subtract(1, 'w');
    }
    return studyDate;
};
